import { secondAxios } from "../../../../../api/axios";

// piping_spec_* / piping_ranges_* are static reference data for the lifetime of
// a session, but building the Spec Library asks for the same handful of tables
// thousands of times (once per expanded row, via updateDerivedFields and
// generateDescriptionFromDB). Cache the in-flight promise so each table is
// fetched exactly once. Call clearPipingTableCache() if the DB is re-imported.
const tableCache = new Map();

export function clearPipingTableCache() {
  tableCache.clear();
}

export async function getPipingTable(tableName) {
  if (!tableName) {
    throw new Error("tableName is required");
  }

  const key = String(tableName);
  if (tableCache.has(key)) return tableCache.get(key);

  const safeTableName = `"${key.replace(/"/g, '""')}"`;

  const request = secondAxios
    .post(`/sqlite-db/query`, {
      dbName: "piping",
      sql: `SELECT * FROM ${safeTableName}`,
    })
    .then((res) => res.data)
    .catch((error) => {
      // Don't cache failures — a transient error must not poison later reads.
      tableCache.delete(key);
      throw error;
    });

  tableCache.set(key, request);
  return request;
}
